/* ==========================================================================
   BEN'SHOME CART (theme v3)

   The cart changes only when the customer presses a button. Nothing in this
   file adds anything on its own, and Delivery Protection is an unticked
   option the customer can take or leave.

   PUBLIC API (build spec 2.6), on window.BH.cart:
     get()                    Promise<cart>
     add(items, opts)         items [{id, quantity}]
                              opts  {source (required), mode 'add'|'ensure', open true}
                              Resolves to the cart after the re-render, rejects
                              with Error(message). 'ensure' adds only variants
                              that are not in the cart yet. Fires bh:cart-added,
                              then bh:cart-updated, then opens the drawer.
     change(lineKey, qty)     Promise<cart>
     setProtection(on, from)  Promise<cart>
     open() close() refresh(open) boards(cart)
   window.BHCart = {open, close, refresh} stays as an alias.

   ONE QUEUE. Every call that reads or writes the cart runs in order through a
   single promise chain, so two taps in a row can never race each other and a
   quick double tap on + really does add two.

   DOM HOOKS, delegated so markup rendered later by other scripts just works:
     [data-bh-add="ID:QTY,ID:QTY"]   optional data-bh-source, data-bh-mode="ensure".
                                     Anchors keep href="/cart/ID:QTY" as the
                                     no-JS fallback.
     form[action*="/cart/add"]       unless it carries data-bh-skip
     .bhc-open                       opens the drawer
     .bhc-count                      gets the board count, class "on" above 0
     [data-bh-checkout]              reports bh:checkout, never blocks the click
     .bh-wallets[data-bh-placement]  a tap is reported as a wallet checkout

   EVENTS on document, never before DOMContentLoaded:
     bh:cart-added {items, source, cart, value}   bh:cart-updated {cart, boards}
     bh:drawer-open {boards}   bh:checkout {from, placement, value, boards}
     bh:protection {on, from}
   Money inside cart objects is in cents, as Shopify sends it. The "value"
   fields are in dollars, ready for analytics.

   No dependencies, no app. Plain fetch against Shopify's own cart routes.
   ========================================================================== */

(function(){
  'use strict';

  if(!window.BH) window.BH = {};
  var BH = window.BH;
  if(BH.cart && BH.cart.v === 3) return;

  var CHECKOUT_URL = '/checkout';
  var TIMEOUT = 15000;
  var MINUS = '−';
  var MSG_FAIL = 'Sorry, that did not go into your cart. Please try again.';
  var MSG_NET = 'We could not reach your cart. Check your connection and try again.';
  var MSG_PICK = 'Choose your size first.';

  /* ---------- small helpers ---------- */

  function noop(){}
  function el(id){ return document.getElementById(id); }
  function each(sel, fn){
    var list = document.querySelectorAll(sel);
    for(var i = 0; i < list.length; i++) fn(list[i]);
  }
  function finderUrl(){ return BH.finderUrl || '/pages/find-my-size'; }
  function contactUrl(){ return BH.contactUrl || '/pages/contact'; }
  function root(){
    var r = String(BH.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  /* /cart is rendered by Liquid, so on that page a change means a reload,
     and the drawer is not used: the page already is the cart. */
  function onCartPage(){ return /\/cart\/?$/.test(location.pathname); }

  /* Titles are typed by a person in the admin and go into innerHTML. */
  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Follows the shop's own money format (BH.money, printed by theme.liquid),
     so the drawer and the checkout never disagree on how a price looks. */
  function money(cents){
    var c = Math.abs(Math.round(Number(cents) || 0));
    var fmt = (typeof BH.money === 'string' && BH.money) ? BH.money : '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    function fixed(dec, th, ds){
      var s = (c / 100).toFixed(dec).split('.');
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (s[1] ? ds + s[1] : '');
    }
    var out;
    switch(m ? m[1] : 'amount'){
      case 'amount_no_decimals': out = fixed(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fixed(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fixed(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fixed(2, "'", '.'); break;
      case 'amount_with_space_separator': out = fixed(2, ' ', ','); break;
      default: out = fixed(2, ',', '.');
    }
    return m ? fmt.replace(m[0], out) : '$' + out;
  }

  function focusEl(n){
    if(!n || typeof n.focus !== 'function') return;
    try { n.focus({preventScroll: true}); } catch(e){ try { n.focus(); } catch(e2){} }
  }

  /* ---------- data printed by cart-drawer.liquid ----------
     #bh-protect  {id, price, title, handle, note, enabled}. Missing means the
                  protection option is off and every protection branch is a
                  no-op.
     #bh-fit      {variantId: {size, fit, type}}, from the fit-line snippet, so
                  the drawer repeats the size in the same words as the page.
                  type is sizing.furniture_type, for the thumb drawing.
     #bhc-fi-tpl  one furniture-icon per type, cloned into the thumb. */

  var PROT = null;
  var FIT = {};

  function readJSON(id){
    var n = el(id);
    if(!n) return null;
    try { return JSON.parse(n.textContent || 'null'); } catch(e){ return null; }
  }
  function loadData(){
    var p = readJSON('bh-protect');
    PROT = (p && p.id) ? p : null;
    var f = readJSON('bh-fit');
    FIT = (f && typeof f === 'object') ? f : {};
  }
  loadData();

  /* ---------- reading a cart ---------- */

  function lines(cart){ return (cart && cart.items) || []; }
  function protHandle(){ return (PROT && PROT.handle) || BH.protectHandle || 'shipping-protection'; }
  function isProt(item){
    if(!item) return false;
    if(PROT && Number(item.variant_id) === Number(PROT.id)) return true;
    return !!item.handle && item.handle === protHandle();
  }
  function boardLines(cart){ return lines(cart).filter(function(i){ return !isProt(i); }); }
  function protLine(cart){
    var a = lines(cart);
    for(var i = 0; i < a.length; i++){ if(isProt(a[i])) return a[i]; }
    return null;
  }
  /* Boards, not cart lines. Protection is an option, not an item. */
  function boards(cart){
    return boardLines(cart).reduce(function(n, i){ return n + (Number(i.quantity) || 0); }, 0);
  }
  function lineByVariant(cart, id){
    var a = lines(cart);
    for(var i = 0; i < a.length; i++){ if(Number(a[i].variant_id) === Number(id)) return a[i]; }
    return null;
  }
  /* ONE ROW PER BOARD. When "Second board, 10% off" lands on one unit of a
     line, Shopify splits that line: a sofa at quantity 2 comes back as two
     lines of 1 with their own keys, one discounted and one not. The drawer
     shows one row per variant with the quantities, prices and discounts
     added up. Minus and plus act on the group's last line; Remove clears
     every line of the group. Keys change after each split, so a row is
     found again by its variant id, never by a key it was drawn with. */
  function groups(cart){
    var out = [];
    var byId = {};
    boardLines(cart).forEach(function(i){
      var id = String(i.variant_id);
      var g = byId[id];
      if(!g){ g = byId[id] = {id: id, items: []}; out.push(g); }
      g.items.push(i);
    });
    return out.map(merge);
  }

  function merge(g){
    var first = g.items[0];
    var row = {};
    for(var k in first){ if(Object.prototype.hasOwnProperty.call(first, k)) row[k] = first[k]; }
    var q = 0, fin = 0, orig = 0;
    var disc = [];
    var byTitle = {};
    g.items.forEach(function(i){
      var f = Number(i.final_line_price != null ? i.final_line_price : i.line_price) || 0;
      q += Number(i.quantity) || 0;
      fin += f;
      orig += Number(i.original_line_price != null ? i.original_line_price : f) || 0;
      (i.line_level_discount_allocations || []).forEach(function(a){
        if(!a || !(Number(a.amount) > 0)) return;
        var t = (a.discount_application && a.discount_application.title) || 'Discount';
        if(!byTitle[t]){ byTitle[t] = {amount: 0, discount_application: {title: t}}; disc.push(byTitle[t]); }
        byTitle[t].amount += Number(a.amount);
      });
    });
    row.quantity = q;
    row.final_line_price = fin;
    row.original_line_price = orig;
    row.line_level_discount_allocations = disc;
    row.items = g.items;
    row.key = g.items[g.items.length - 1].key;
    return row;
  }

  function groupOf(cart, variantId){
    var a = groups(cart);
    for(var i = 0; i < a.length; i++){ if(String(a[i].variant_id) === String(variantId)) return a[i]; }
    return null;
  }
  function fitFor(item){
    var f = FIT[String(item.variant_id)] || {};
    var size = f.size || '';
    if(!size){
      var t = item.variant_title || '';
      if(t && t.toLowerCase() !== 'default title') size = t;
    }
    return {size: size, fit: f.fit || '', type: f.type || ''};
  }
  /* The furniture drawing for a type, from #bhc-fi-tpl (cart-drawer.liquid
     renders the furniture-icon snippet once per type into it). Empty string
     when the type is unknown or the template is missing. */
  var FI_TYPES = {'recliner': 1, 'loveseat': 1, 'sofa-med': 1, 'sofa-long': 1, 'sectional': 1};

  /* The name a screen reader hears on a row's controls: the board and its
     size, e.g. "Sofa board 58″ to 67″, size 23", so "Reduce quantity" on
     the second row never sounds like the first. Labels are the shared
     vocabulary (spec 2.2). Without a furniture type: the title plus the
     size line. */
  var TYPE_LABEL = {'recliner': 'Recliner', 'loveseat': 'Loveseat', 'sofa-med': 'Sofa',
                    'sofa-long': 'Long sofa', 'sectional': 'Sectional'};
  function nameFor(item, f){
    f = f || fitFor(item);
    var title = item.product_title || item.title || '';
    if(f.size && f.type && Object.prototype.hasOwnProperty.call(TYPE_LABEL, f.type)){
      return TYPE_LABEL[f.type] + ' board ' + f.size.replace(' wide', '');
    }
    return title + (f.size ? ', ' + f.size : '');
  }

  function iconFor(type){
    if(!type || !Object.prototype.hasOwnProperty.call(FI_TYPES, type)) return '';
    var tpl = el('bhc-fi-tpl');
    var box = tpl && (tpl.content || tpl);
    if(!box || !box.querySelector) return '';
    var n = box.querySelector('[data-fi="' + type + '"]');
    return n ? n.innerHTML.trim() : '';
  }

  /* ---------- events ----------
     Queued until the DOM is ready, so a listener bound at DOMContentLoaded
     (benshome-track.js) never misses the first bh:cart-updated. */

  var ready = document.readyState === 'complete';
  var early = [];

  function emit(name, detail){
    if(!ready){ early.push([name, detail]); return; }
    var ev;
    try { ev = new CustomEvent(name, {detail: detail}); }
    catch(e){
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(name, false, false, detail);
    }
    document.dispatchEvent(ev);
  }

  function whenReady(fn){
    if(document.readyState === 'complete'){ fn(); return; }
    var done = false;
    function go(){ if(done) return; done = true; fn(); }
    document.addEventListener('DOMContentLoaded', go);
    window.addEventListener('load', go);
  }

  /* ---------- network ---------- */

  function request(url, body){
    var opts = {method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: {'Accept': 'application/json'}};
    if(body){
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    var ctrl = null;
    try { ctrl = new AbortController(); opts.signal = ctrl.signal; } catch(e){ ctrl = null; }

    return new Promise(function(resolve, reject){
      /* A request that never answers would stall the queue for good. */
      var timer = setTimeout(function(){
        if(ctrl){ try { ctrl.abort(); } catch(e){} }
        reject(new Error(MSG_NET));
      }, TIMEOUT);

      fetch(url, opts).then(function(r){
        return r.text().then(function(t){
          var data = null;
          try { data = t ? JSON.parse(t) : null; } catch(e){ data = null; }
          if(!r.ok || !data){
            var d = data && (data.description || data.message);
            throw new Error(typeof d === 'string' && d ? d : MSG_FAIL);
          }
          return data;
        });
      }, function(){ throw new Error(MSG_NET); })
      .then(function(d){ clearTimeout(timer); resolve(d); },
            function(err){ clearTimeout(timer); reject(err); });
    });
  }

  function fetchCart(){ return request(root() + 'cart.js'); }
  function postAdd(list){ return request(root() + 'cart/add.js', {items: list}); }
  function postChange(key, qty){ return request(root() + 'cart/change.js', {id: String(key), quantity: qty}); }
  /* {lineKey: quantity, ...} in one request; cart/update.js takes line keys. */
  function postUpdate(map){ return request(root() + 'cart/update.js', {updates: map}); }

  /* ---------- the queue ---------- */

  var queue = Promise.resolve();
  var pending = 0;

  function enqueue(task){
    pending++;
    var run = queue.then(function(){ return task(); });
    function settled(){ pending--; }
    queue = run.then(settled, settled);
    return run;
  }

  /* ---------- state ---------- */

  var state = {cart: null, boards: 0, open: false, opener: null};

  /* RECONCILE does exactly two things and never adds anything:
       no boards left  -> the protection line goes
       protection > 1  -> back to 1
     It never runs on the way to checkout. A failed tidy-up keeps the cart as
     it was rather than blocking the customer. */
  function reconcile(cart){
    var line = protLine(cart);
    if(!line) return Promise.resolve({cart: cart, changed: false});
    var q = Number(line.quantity) || 0;
    var want = boards(cart) > 0 ? Math.min(q, 1) : 0;
    if(want === q) return Promise.resolve({cart: cart, changed: false});
    return postChange(line.key, want).then(
      function(c){ return {cart: c, changed: true}; },
      function(){ return {cart: cart, changed: false}; }
    );
  }

  function commit(cart){
    state.cart = cart;
    state.boards = boards(cart);
    render(cart);
    return cart;
  }

  function apply(p){
    return p.then(reconcile).then(function(r){ commit(r.cart); return r; });
  }

  function updated(){ emit('bh:cart-updated', {cart: state.cart, boards: state.boards}); }

  function afterChange(cart){
    if(onCartPage()) location.reload();
    return cart;
  }

  /* ---------- public operations ---------- */

  function refresh(open){
    return enqueue(function(){
      return apply(fetchCart()).then(function(r){ updated(); return r; });
    }).then(function(r){
      if(r.changed && onCartPage()){ location.reload(); return r.cart; }
      if(open) openDrawer();
      return r.cart;
    });
  }

  function normalize(list){
    if(!list) return [];
    if(!Array.isArray(list)) list = [list];
    var out = [];
    list.forEach(function(it){
      if(!it) return;
      var raw = it.id != null ? it.id : it.variant_id;
      var id = String(raw == null ? '' : raw).trim();
      if(!/^\d+$/.test(id)) return;
      var q = parseInt(it.quantity != null ? it.quantity : it.qty, 10);
      var row = {id: Number(id), quantity: q > 0 ? q : 1};
      if(it.properties && typeof it.properties === 'object') row.properties = it.properties;
      out.push(row);
    });
    return out;
  }

  function describe(list, cart){
    return list.map(function(it){
      var line = lineByVariant(cart, it.id) || {};
      var unit = line.original_price != null ? line.original_price : line.price;
      return {
        id: it.id,
        quantity: it.quantity,
        price: Number(unit) || 0,
        title: line.product_title || line.title || '',
        handle: line.handle || '',
        size: fitFor({variant_id: it.id, variant_title: line.variant_title}).size
      };
    });
  }

  function dollars(list){
    return Math.round(list.reduce(function(s, i){ return s + i.price * i.quantity; }, 0)) / 100;
  }

  function add(list, opts){
    opts = opts || {};
    var source = String(opts.source || 'unknown');
    var ensure = opts.mode === 'ensure';
    var open = opts.open !== false;
    var todo = normalize(list);
    if(!todo.length) return Promise.reject(new Error(MSG_FAIL));

    return enqueue(function(){
      var before = ensure ? fetchCart() : Promise.resolve(null);
      return before.then(function(cart){
        var send = cart ? todo.filter(function(it){ return !lineByVariant(cart, it.id); }) : todo;
        if(!send.length) return {cart: cart, added: []};
        return postAdd(send).then(fetchCart).then(function(c){ return {cart: c, added: send}; });
      }).then(function(r){
        return reconcile(r.cart).then(function(rr){ return {cart: rr.cart, added: r.added}; });
      }).then(function(r){
        commit(r.cart);
        var info = describe(r.added, r.cart);
        if(info.length){
          emit('bh:cart-added', {items: info, source: source, cart: r.cart, value: dollars(info)});
        }
        updated();
        if(info.length){
          say('Added to cart: ' + info.map(function(i){ return i.title + (i.size ? ', ' + i.size : ''); }).join('; '),
              open && !onCartPage());
        }
        return r.cart;
      });
    }).then(function(cart){
      if(onCartPage()){ location.reload(); return cart; }
      if(open) openDrawer(opts.opener || null);
      return cart;
    });
  }

  function change(key, qty){
    if(key == null || key === '') return Promise.reject(new Error(MSG_FAIL));
    var q = Math.max(0, parseInt(qty, 10) || 0);
    return enqueue(function(){
      return apply(postChange(key, q)).then(function(r){ updated(); return r.cart; });
    }).then(afterChange);
  }

  /* A drawer row (one variant, maybe several split lines, see groups()).
     Relative to the cart as it is when the step runs, not as it was drawn,
     so taps queued behind each other add up. The change goes to the group's
     last line: plus raises it, minus lowers it or, when it is a split-off
     line of 1, removes it. The row never goes below 1: removing it is what
     the Remove button is for. */
  function stepGroup(variantId, delta){
    return enqueue(function(){
      var g = groupOf(state.cart, variantId);
      var p;
      if(!g){
        p = fetchCart();
      } else {
        var last = g.items[g.items.length - 1];
        var lq = Number(last.quantity) || 0;
        var want = Math.max(1, g.quantity + delta);
        var q = Math.max(0, lq + (want - g.quantity));
        p = (want === g.quantity || q === lq) ? Promise.resolve(state.cart) : postChange(last.key, q);
      }
      return apply(p).then(function(r){ updated(); return r.cart; });
    }).then(afterChange);
  }

  /* Remove for a drawer row: every line of that variant, read from a fresh
     cart so no key is stale, in one request. */
  function removeGroup(variantId){
    return enqueue(function(){
      return apply(fetchCart().then(function(cart){
        var g = groupOf(cart, variantId);
        if(!g) return cart;
        var map = {};
        g.items.forEach(function(i){ map[String(i.key)] = 0; });
        return postUpdate(map);
      })).then(function(r){ updated(); return r.cart; });
    }).then(afterChange);
  }

  /* Protection is only ever added here, by the customer ticking the box.
     Never on an empty cart, never more than one. */
  function setProtection(on, from){
    on = !!on;
    from = from || 'drawer';
    if(!PROT) return Promise.reject(new Error(MSG_FAIL));
    return enqueue(function(){
      var had = false;
      return apply(fetchCart().then(function(cart){
        var line = protLine(cart);
        had = !!line;
        if(on){
          if(!boards(cart) || line) return cart;
          return postAdd([{id: Number(PROT.id), quantity: 1}]).then(fetchCart);
        }
        return line ? postChange(line.key, 0) : cart;
      })).then(function(r){
        var has = !!protLine(r.cart);
        if(has !== had) emit('bh:protection', {on: has, from: from});
        updated();
        return r.cart;
      });
    }).then(afterChange);
  }

  /* ---------- live announcements ---------- */

  function say(msg, inDrawer){
    var n = (inDrawer && el('bhc-live')) || el('bhc-live-page') || el('bhc-live');
    if(!n) return;
    n.textContent = '';
    setTimeout(function(){ n.textContent = msg; }, 80);
  }

  /* ---------- the drawer: open, close, focus ---------- */

  var INERT = typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
  var blocked = [];

  function wrapEl(){ return el('bh-cart'); }
  function panelEl(){ var w = wrapEl(); return w ? w.querySelector('.bhc-panel') : null; }

  /* Everything outside the drawer goes inert while it is open, so neither
     Tab nor a screen reader can wander behind the scrim. Things added to the
     page after opening (a wallet's own sign-in window) are left alone. */
  function block(on){
    if(!on){
      if(INERT) blocked.forEach(function(n){ n.removeAttribute('inert'); });
      blocked = [];
      return;
    }
    blocked = [];
    var wrap = wrapEl();
    var kids = document.body ? document.body.children : [];
    for(var i = 0; i < kids.length; i++){
      var n = kids[i];
      if(n === wrap || (wrap && n.contains(wrap)) || n.id === 'bhc-live-page') continue;
      if(/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(n.tagName) || n.hasAttribute('inert')) continue;
      blocked.push(n);
      if(INERT) n.setAttribute('inert', '');
    }
  }

  function openDrawer(opener){
    if(onCartPage()) return;
    var wrap = wrapEl();
    if(!wrap) return;
    if(state.open){ checkWallets(); return; }
    state.open = true;
    var active = document.activeElement;
    state.opener = opener || (active && active !== document.body ? active : null);
    wrap.classList.add('on');
    wrap.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bh-noscroll', 'bh-cart-open');
    block(true);
    footRoom();
    focusEl(wrap.querySelector('.bhc-close') || panelEl());
    emit('bh:drawer-open', {boards: state.boards});
    checkWallets();
  }

  function closeDrawer(){
    var wrap = wrapEl();
    if(!wrap || !state.open) return;
    state.open = false;
    wrap.classList.remove('on');
    document.body.classList.remove('bh-noscroll', 'bh-cart-open');
    block(false);
    /* Focus leaves the drawer before it is hidden from assistive tech:
       aria-hidden on an ancestor of the focused element is blocked by the
       browser. Back to the opener; with no opener (opened by script), off
       the drawer altogether. */
    var o = state.opener;
    state.opener = null;
    if(o && document.documentElement.contains(o) && !wrap.contains(o)) focusEl(o);
    var a = document.activeElement;
    if(a && a !== document.body && wrap.contains(a) && typeof a.blur === 'function') a.blur();
    wrap.setAttribute('aria-hidden', 'true');
  }

  /* The cart has never loaded and the retry failed too: say so and give the
     /cart page, rather than open an empty panel. The next good read redraws it. */
  function loadFailed(){
    if(state.cart) return;
    var body = el('bhc-body');
    if(!body) return;
    body.innerHTML = '<p class="bh-err" role="alert">' + esc(MSG_NET) +
      ' <a href="' + esc(root() + 'cart') + '">Open the cart page</a></p>';
    var foot = el('bhc-foot');
    var extra = el('bhc-extra');
    if(foot) foot.innerHTML = '';
    if(extra) extra.hidden = true;
  }

  /* Opens straight away with what is already known, then checks the server,
     so the panel never waits on a request to appear. */
  function open(opener){
    if(onCartPage()) return Promise.resolve(state.cart);
    if(!state.cart){
      return refresh(false).then(function(c){ openDrawer(opener); return c; },
                                 function(){ loadFailed(); openDrawer(opener); return null; });
    }
    openDrawer(opener);
    return refresh(false).catch(function(){ return state.cart; });
  }

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),' +
                  'select:not([disabled]),textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"])';

  function focusables(scope){
    return Array.prototype.filter.call(scope.querySelectorAll(FOCUSABLE), function(n){
      if(n.getAttribute('tabindex') === '-1' || n.closest('[hidden]')) return false;
      return !!(n.offsetWidth || n.offsetHeight || n.getClientRects().length);
    });
  }

  /* Re-rendering the lines replaces the button that was just pressed. These
     two put focus back on the same control so a keyboard user keeps their
     place. */
  function focusMark(){
    var a = document.activeElement;
    var wrap = wrapEl();
    if(!a || !wrap || !wrap.contains(a)) return null;
    var kind = a.classList.contains('bhc-step') ? 'step' + a.getAttribute('data-step')
      : a.classList.contains('bhc-remove') ? 'remove'
      : a.classList.contains('bhc-prot-x') ? 'prot'
      : a.classList.contains('bhc-go') ? 'go' : null;
    if(!kind) return null;
    var row = a.closest('.bhc-item');
    var rows = wrap.querySelectorAll('.bhc-item');
    var index = -1;
    for(var i = 0; i < rows.length; i++){ if(rows[i] === row) index = i; }
    return {kind: kind, key: row ? row.getAttribute('data-variant') : null, index: index};
  }

  function focusBack(mark){
    var wrap = wrapEl();
    if(!mark || !wrap) return;
    var a = document.activeElement;
    if(a && a !== document.body && wrap.contains(a)) return;
    var target = null;
    if(mark.kind === 'prot') target = wrap.querySelector('.bhc-prot-x');
    else if(mark.kind === 'go') target = wrap.querySelector('.bhc-go');
    else if(mark.key){
      var rows = wrap.querySelectorAll('.bhc-item');
      var row = null;
      for(var i = 0; i < rows.length; i++){
        if(rows[i].getAttribute('data-variant') === mark.key){ row = rows[i]; break; }
      }
      if(row){
        if(mark.kind === 'remove') target = row.querySelector('.bhc-remove');
        else {
          target = row.querySelector('.bhc-step[data-step="' + (mark.kind === 'step-1' ? '-1' : '1') + '"]');
          if(target && target.disabled) target = row.querySelector('.bhc-step[data-step="1"]');
        }
      } else if(rows.length){
        row = rows[Math.min(Math.max(mark.index, 0), rows.length - 1)];
        target = row.querySelector('.bhc-remove');
      }
    }
    focusEl(target || wrap.querySelector('.bhc-empty a') || wrap.querySelector('.bhc-close'));
  }

  /* ---------- the drawer: markup ---------- */

  function thumb(item){
    var src = (item.featured_image && item.featured_image.url) || item.image || '';
    if(!src) return '';
    if(src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
  }

  function lineHTML(item){
    var f = fitFor(item);
    var title = item.product_title || item.title || '';
    var q = Number(item.quantity) || 0;
    var fin = Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
    var orig = Number(item.original_line_price != null ? item.original_line_price : fin) || 0;
    var cut = fin < orig;
    var url = esc(item.url || '#');
    var img = thumb(item);

    /* One line per discount, named as the checkout names it, so the saving
       on a second board is visible before anyone pays. A BXGY discount also
       sends a zero allocation for the full-price board; that one is skipped,
       so no "-$0.00" line ever appears under a board that is not discounted. */
    var disc = '';
    (item.line_level_discount_allocations || []).forEach(function(a){
      if(!a || !(Number(a.amount) > 0)) return;
      var t = (a.discount_application && a.discount_application.title) || 'Discount';
      disc += '<p class="bhc-disc">' + esc(t) + ' ' + MINUS + money(a.amount) + '</p>';
    });

    /* The board's furniture, drawn with the board under the cushions, when
       the variant has a furniture type; otherwise the product photo. */
    var icon = iconFor(f.type);
    var name = nameFor(item, f);

    return '' +
      '<li class="bhc-item" data-key="' + esc(item.key) + '" data-variant="' + esc(item.variant_id) + '">' +
        '<a class="bhc-img' + (icon ? ' bhc-img--icon' : '') + '" href="' + url + '" tabindex="-1" aria-hidden="true">' +
          (icon || (img ? '<img src="' + esc(img) + '" alt="" width="76" height="76" loading="lazy">' : '')) +
        '</a>' +
        '<div class="bhc-info">' +
          '<div class="bhc-row1">' +
            '<a class="bhc-title" href="' + url + '">' + esc(title) + '</a>' +
            '<p class="bhc-price">' +
              (cut ? '<s><span class="visually-hidden">Was </span>' + money(orig) + '</s>' : '') +
              '<b>' + (cut ? '<span class="visually-hidden">Now </span>' : '') + money(fin) + '</b>' +
            '</p>' +
          '</div>' +
          (f.size ? '<p class="bhc-size">' + esc(f.size) + '</p>' : '') +
          (f.fit ? '<p class="bhc-fitline">' + esc(f.fit) + '</p>' : '') +
          disc +
          (q > 1 ? '<p class="bhc-each">' + money(item.original_price) + ' each</p>' : '') +
          '<div class="bhc-qty">' +
            '<div class="bhc-stepper" role="group" aria-label="' + esc('Quantity, ' + name) + '">' +
              '<button type="button" class="bhc-step" data-step="-1"' + (q <= 1 ? ' disabled' : '') +
                ' aria-label="' + esc('Reduce quantity, ' + name) + '">&minus;</button>' +
              '<span class="bhc-n">' + q + '</span>' +
              '<button type="button" class="bhc-step" data-step="1" aria-label="' + esc('Increase quantity, ' + name) + '">+</button>' +
            '</div>' +
            '<button type="button" class="bhc-remove" aria-label="' + esc('Remove ' + name) + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</li>';
  }

  function checkHTML(){
    return '<p class="bhc-check">Before you pay, check the size against your bare seat base, cushions off. ' +
      'Not sure? <a href="' + esc(contactUrl()) + '?topic=sizing">Send us your numbers</a> and we\'ll confirm.</p>';
  }

  /* Unticked unless the line is already in the cart. The label is the
     control's accessible name, price included.
     It sits in the footer, right above the total it changes, so it can never
     be hidden under the sticky footer: with two boards on a 375x812 phone the
     footer used to cover it, and a tick now shows its effect on the total in
     the same glance. */
  function protHTML(cart){
    if(!PROT) return '';
    var line = protLine(cart);
    if(!line && PROT.enabled === false) return '';
    var on = !!line;
    return '' +
      '<label class="bhc-prot bhc-prot--foot' + (on ? ' on' : '') + '">' +
        '<input type="checkbox" class="bhc-prot-x" data-bh-from="drawer"' + (on ? ' checked' : '') + '> ' +
        '<span class="bhc-prot-t"><b>Add Delivery Protection for ' + money(PROT.price) + '</b> (optional)' +
          (PROT.note ? ' <small>' + esc(PROT.note) + '</small>' : '') +
        '</span>' +
      '</label>';
  }

  function footHTML(cart){
    var rows = '';
    (cart.cart_level_discount_applications || []).forEach(function(d){
      if(!d || !(Number(d.total_allocated_amount) > 0)) return;
      rows += '<p class="bhc-row bhc-disc"><span>' + esc(d.title || 'Discount') + '</span>' +
              '<span>' + MINUS + money(d.total_allocated_amount) + '</span></p>';
    });
    var total = money(cart.total_price);
    return protHTML(cart) + rows +
      '<p class="bhc-total"><span>Total</span> <b>' + total + '</b></p>' +
      '<p class="bhc-ship">Shipping: free to the lower 48 · Tax added at checkout</p>' +
      '<a class="btn btn-primary btn-block btn-lg bhc-go" href="' + CHECKOUT_URL + '" data-bh-checkout="drawer">' +
        'Check out, ' + total + '</a>';
  }

  function emptyHTML(){
    return '<div class="bhc-empty"><p class="bhc-empty-h">Your cart is empty</p>' +
      '<p>Tell us your furniture and we\'ll show you the size that fits.</p>' +
      '<a class="btn btn-primary btn-block btn-lg" href="' + esc(finderUrl()) + '">Find my size</a></div>';
  }

  function render(cart){
    var n = boards(cart);

    each('.bhc-count', function(c){
      c.textContent = String(n);
      c.classList.toggle('on', n > 0);
      c.hidden = n === 0;
    });
    each('.bhc-fab', function(f){
      f.hidden = n === 0;
      f.setAttribute('aria-label', n ? 'Open cart, ' + n + (n === 1 ? ' board' : ' boards') : 'Open cart');
    });

    var wrap = wrapEl();
    if(!wrap) return;
    var head = wrap.querySelector('.bhc-n-items');
    if(head) head.textContent = n ? '(' + n + (n === 1 ? ' board)' : ' boards)') : '';

    var body = el('bhc-body');
    var foot = el('bhc-foot');
    var extra = el('bhc-extra');
    if(!body) return;
    var mark = focusMark();

    if(!n){
      var tpl = el('bhc-empty-tpl');
      body.innerHTML = '';
      if(tpl && tpl.content) body.appendChild(tpl.content.cloneNode(true));
      else body.innerHTML = emptyHTML();
      if(foot) foot.innerHTML = '';
      if(extra) extra.hidden = true;
    } else {
      body.innerHTML =
        '<ul class="bhc-lines" role="list">' + groups(cart).map(lineHTML).join('') + '</ul>' +
        checkHTML();
      if(foot) foot.innerHTML = footHTML(cart);
      if(extra) extra.hidden = false;
    }

    footRoom();
    if(mark && state.open) focusBack(mark);
  }

  /* The footer is sticky, so anything focused or scrolled to by the keyboard
     (the "Send us your numbers" link in the size check) is kept above it:
     the scroll column's scroll-padding follows the footer's real height. */
  function footRoom(){
    var foot = el('bhc-foot');
    var wrap = wrapEl();
    var scroll = wrap && wrap.querySelector('.bhc-scroll');
    if(!scroll || !scroll.style) return;
    var h = (foot && foot.offsetHeight) || 0;
    scroll.style.setProperty('--bhc-foot-h', h + 'px');
  }

  /* ---------- express wallets ----------
     Shopify's buttons may not draw inside a cart that was filled without a
     page load. If nothing visible has appeared 1.5s after opening, a plain
     line says the express options are on the next step. */

  var walletTimer = null;

  function hasVisible(box){
    if(!box) return false;
    var kids = box.children;
    for(var i = 0; i < kids.length; i++){
      var r = kids[i].getBoundingClientRect();
      if(r.width > 8 && r.height > 8) return true;
    }
    return false;
  }

  function checkWallets(){
    clearTimeout(walletTimer);
    var wrap = wrapEl();
    var fb = wrap && wrap.querySelector('.bhc-wallets-fallback');
    if(!fb) return;
    if(!state.boards){ fb.hidden = true; return; }
    walletTimer = setTimeout(function(){
      if(!state.open) return;
      fb.hidden = hasVisible(wrap.querySelector('.bh-wallets'));
    }, 1500);
  }

  var walletAt = 0;
  function walletTap(box){
    var now = Date.now();
    if(now - walletAt < 1500) return;
    walletAt = now;
    var placement = box.getAttribute('data-bh-placement') || '';
    emit('bh:checkout', {
      from: 'wallet',
      placement: placement,
      value: placement === 'pdp' ? null : cartValue(),
      boards: state.boards
    });
  }

  function cartValue(){
    return state.cart ? Math.round(Number(state.cart.total_price) || 0) / 100 : null;
  }

  /* ---------- controls: feedback ---------- */

  function busy(node, on){
    if(!node || !node.classList) return;
    node.classList.toggle('is-loading', !!on);
    if(on) node.setAttribute('aria-busy', 'true');
    else node.removeAttribute('aria-busy');
  }

  function isBusy(node){
    return !!node && (node.classList.contains('is-loading') || node.getAttribute('aria-busy') === 'true');
  }

  /* "Added" for 1.6s, then the original label, unless something else has
     rewritten the label in the meantime. */
  function flash(node){
    if(!node || !document.documentElement.contains(node)) return;
    var input = node.tagName === 'INPUT';
    if(node._bhFlash) clearTimeout(node._bhFlash);
    else node._bhLabel = input ? node.value : node.innerHTML;
    if(input) node.value = 'Added'; else node.textContent = 'Added';
    node._bhFlash = setTimeout(function(){
      node._bhFlash = null;
      if(input){ if(node.value === 'Added') node.value = node._bhLabel; }
      else if(node.textContent === 'Added') node.innerHTML = node._bhLabel;
    }, 1600);
  }

  function errText(err){ return (err && err.message) || MSG_FAIL; }

  function showError(node, msg){
    if(!node || !node.parentNode) return;
    var n = node.nextElementSibling;
    if(!n || !n.classList.contains('bh-err')){
      n = document.createElement('p');
      n.className = 'bh-err';
      n.setAttribute('role', 'alert');
      node.parentNode.insertBefore(n, node.nextSibling);
    }
    n.textContent = msg;
  }

  function clearError(node){
    var n = node && node.nextElementSibling;
    if(n && n.classList.contains('bh-err') && n.parentNode) n.parentNode.removeChild(n);
  }

  /* ---------- controls: handlers ---------- */

  function parseSpec(s){
    return normalize(String(s || '').split(',').map(function(part){
      var bits = part.split(':');
      return {id: (bits[0] || '').trim(), quantity: bits[1]};
    }));
  }

  function onAddClick(e, node){
    if(isBusy(node) || node.disabled || node.getAttribute('aria-disabled') === 'true'){
      e.preventDefault();
      return;
    }
    var list = parseSpec(node.getAttribute('data-bh-add'));
    if(!list.length) return; /* malformed: the href works as it would without JS */
    e.preventDefault();
    busy(node, true);
    clearError(node);
    add(list, {
      source: node.getAttribute('data-bh-source') || 'button',
      mode: node.getAttribute('data-bh-mode') === 'ensure' ? 'ensure' : 'add',
      opener: node
    }).then(function(){
      busy(node, false);
      flash(node);
    }, function(err){
      busy(node, false);
      showError(node, errText(err));
    });
  }

  function onCheckout(e, node){
    var from = node.getAttribute('data-bh-checkout') || 'drawer';
    function report(){
      emit('bh:checkout', {from: from, placement: from, value: cartValue(), boards: state.boards});
    }
    var plain = !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0);
    /* A tap on Check out while a change is still on its way (a tick on
       protection, a quantity) waits for it, so checkout gets the cart the
       customer is looking at. */
    if(pending > 0 && node.tagName === 'A' && plain){
      e.preventDefault();
      busy(node, true);
      var href = node.getAttribute('href') || CHECKOUT_URL;
      queue.then(function(){ report(); window.location.href = href; });
      return;
    }
    report();
  }

  function onStep(btn){
    if(btn.disabled) return;
    var row = btn.closest('.bhc-item');
    var vid = row && row.getAttribute('data-variant');
    if(!vid) return;
    var delta = Number(btn.getAttribute('data-step')) || 0;
    row.classList.add('is-busy');
    stepGroup(vid, delta).then(function(cart){
      var g = groupOf(cart, vid);
      if(g) say('Quantity ' + g.quantity + ', ' + nameFor(g), true);
    }, function(err){
      row.classList.remove('is-busy');
      showError(row.querySelector('.bhc-qty') || row, errText(err));
    });
  }

  function onRemove(btn){
    var row = btn.closest('.bhc-item');
    var vid = row && row.getAttribute('data-variant');
    if(!vid) return;
    var t = row.querySelector('.bhc-title');
    var title = t ? t.textContent : '';
    row.classList.add('is-busy');
    removeGroup(vid).then(function(){
      say('Removed from cart: ' + title, true);
    }, function(err){
      row.classList.remove('is-busy');
      showError(row.querySelector('.bhc-qty') || row, errText(err));
    });
  }

  function collectProps(form){
    var out = null;
    var els = form.elements || [];
    for(var i = 0; i < els.length; i++){
      var f = els[i];
      var m = /^properties\[(.+)\]$/.exec(f.name || '');
      if(!m || f.disabled || f.value === '') continue;
      if((f.type === 'checkbox' || f.type === 'radio') && !f.checked) continue;
      (out = out || {})[m[1]] = f.value;
    }
    return out;
  }

  /* ---------- listeners (bound now, so nothing clicked early is lost) ---------- */

  document.addEventListener('click', function(e){
    var t = e.target;
    if(!t || !t.closest) return;

    var n = t.closest('[data-bh-add]');
    if(n){ onAddClick(e, n); return; }

    n = t.closest('[data-bh-checkout]');
    if(n){ onCheckout(e, n); return; }

    if(t.closest('.bhc-close') || t.closest('.bhc-scrim')){
      e.preventDefault();
      closeDrawer();
      return;
    }

    n = t.closest('.bhc-step');
    if(n && n.closest('#bh-cart')){ e.preventDefault(); onStep(n); return; }

    n = t.closest('.bhc-remove');
    if(n && n.closest('#bh-cart')){ e.preventDefault(); onRemove(n); return; }

    n = t.closest('.bhc-open');
    if(n){
      if(onCartPage()) return;
      if(n.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0)) return;
      e.preventDefault();
      open(n);
    }
  });

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || form.tagName !== 'FORM' || e.defaultPrevented) return;
    if((form.getAttribute('action') || '').indexOf('/cart/add') < 0 || form.hasAttribute('data-bh-skip')) return;

    var sub = e.submitter || null;
    var own = form.querySelector('[type="submit"], button:not([type])');
    var ctl = sub || own;
    var anchor = (sub && form.contains(sub)) ? sub : (own || sub || form);
    e.preventDefault();
    if(form.getAttribute('aria-busy') === 'true' || isBusy(ctl)) return;

    var idEl = form.elements ? form.elements.namedItem('id') : form.querySelector('[name="id"]');
    var id = idEl ? String(idEl.value || '') : '';
    if(!/^\d+$/.test(id)){ showError(anchor, MSG_PICK); return; }

    var qEl = form.elements ? form.elements.namedItem('quantity') : form.querySelector('[name="quantity"]');
    var item = {id: id, quantity: Math.max(1, parseInt(qEl && qEl.value, 10) || 1)};
    var props = collectProps(form);
    if(props) item.properties = props;

    var source = (sub && sub.getAttribute('data-bh-source')) || form.getAttribute('data-bh-source') || 'form';

    form.setAttribute('aria-busy', 'true');
    busy(ctl, true);
    clearError(anchor);
    add([item], {source: source, opener: ctl}).then(function(){
      form.removeAttribute('aria-busy');
      busy(ctl, false);
      flash(ctl);
    }, function(err){
      form.removeAttribute('aria-busy');
      busy(ctl, false);
      showError(anchor, errText(err));
    });
  });

  /* The protection tickbox, in the drawer and on /cart. Disabled while the
     request runs and put back the way it was if it fails, so the tick always
     describes the cart. */
  document.addEventListener('change', function(e){
    var box = e.target;
    if(!box || !box.classList || !box.classList.contains('bhc-prot-x')) return;
    var from = box.getAttribute('data-bh-from') || (box.closest('#bh-cart') ? 'drawer' : 'cart');
    var want = box.checked;
    var label = box.closest('.bhc-prot');
    box.disabled = true;
    if(label) label.classList.add('is-busy');
    setProtection(want, from).catch(function(err){
      box.disabled = false;
      box.checked = !want;
      if(label) label.classList.remove('is-busy');
      showError(label || box, errText(err));
    });
  });

  /* Wallet buttons live in shadow DOM or iframes. pointerdown sees the first
     (retargeted to the host); a window blur onto an iframe catches the second.
     The iframe counts once per move into it: while it keeps focus, a later
     blur is a tab or app switch, not a new tap. Focus back on the page resets. */
  document.addEventListener('pointerdown', function(e){
    var t = e.target;
    var box = t && t.closest ? t.closest('.bh-wallets[data-bh-placement]') : null;
    if(box) walletTap(box);
  }, true);

  var walletFrame = null;
  function frameLeft(){
    setTimeout(function(){
      if(walletFrame && document.activeElement !== walletFrame) walletFrame = null;
    }, 0);
  }

  window.addEventListener('blur', function(){
    setTimeout(function(){
      var a = document.activeElement;
      if(!a || a.tagName !== 'IFRAME' || !a.closest || a === walletFrame) return;
      var box = a.closest('.bh-wallets[data-bh-placement]');
      if(!box) return;
      walletFrame = a;
      walletTap(box);
    }, 0);
  });
  window.addEventListener('focus', frameLeft);
  document.addEventListener('focusin', frameLeft);

  /* Esc closes. Tab cycles inside the panel. Focus that is already somewhere
     else (a wallet's own window) is left alone. */
  document.addEventListener('keydown', function(e){
    if(!state.open) return;
    var panel = panelEl();
    if(!panel) return;
    var a = document.activeElement;
    var inside = !!a && panel.contains(a);
    var loose = !a || a === document.body || a === document.documentElement;

    if(e.key === 'Escape' || e.key === 'Esc'){
      if(inside || loose){ e.preventDefault(); closeDrawer(); }
      return;
    }
    if(e.key !== 'Tab' || !(inside || loose)) return;

    var f = focusables(panel);
    if(!f.length){ e.preventDefault(); focusEl(panel); return; }
    var first = f[0];
    var last = f[f.length - 1];
    if(loose){ e.preventDefault(); focusEl(e.shiftKey ? last : first); return; }
    if(e.shiftKey && (a === first || a === panel)){ e.preventDefault(); focusEl(last); }
    else if(!e.shiftKey && a === last){ e.preventDefault(); focusEl(first); }
  });

  /* Browsers without inert: pull focus back if it lands behind the scrim. */
  document.addEventListener('focusin', function(e){
    if(!state.open || INERT) return;
    for(var i = 0; i < blocked.length; i++){
      if(blocked[i].contains(e.target)){
        var p = panelEl();
        focusEl((p && p.querySelector('.bhc-close')) || p);
        return;
      }
    }
  });

  /* A turned phone changes the footer's height. */
  window.addEventListener('resize', function(){ if(state.open) footRoom(); });

  /* Back button from checkout: the page may come back from the cache with an
     old cart in it. */
  window.addEventListener('pageshow', function(e){
    if(e && e.persisted) refresh(false).catch(noop);
  });

  /* Back to this tab after the cart changed in another one: re-read it, so
     the badge, the bar and the drawer show today's cart, not the one this
     page was printed with. /cart is printed by Liquid, so there a changed
     cart means a reload. At most once every 3 seconds. */
  var seenAt = 0;
  document.addEventListener('visibilitychange', function(){
    if(document.visibilityState !== 'visible' || !ready) return;
    var now = Date.now();
    if(now - seenAt < 3000) return;
    seenAt = now;
    var before = state.cart;
    refresh(false).then(function(c){
      if(!onCartPage() || !before || !c) return;
      if(before.item_count !== c.item_count || before.total_price !== c.total_price) location.reload();
    }).catch(noop);
  });

  /* ---------- public API ---------- */

  BH.cart = {
    v: 3,
    get: function(){ return enqueue(fetchCart); },
    add: add,
    change: change,
    setProtection: setProtection,
    open: function(){ return open(); },
    close: closeDrawer,
    refresh: function(o){ return refresh(!!o); },
    boards: function(cart){ return cart ? boards(cart) : state.boards; }
  };

  window.BHCart = {open: BH.cart.open, close: closeDrawer, refresh: BH.cart.refresh};

  /* ---------- start ----------
     Read the real cart once the page is ready. This fires the first
     bh:cart-updated, which the counts, the sticky bar and tracking wait on. */

  whenReady(function(){
    ready = true;
    var q = early;
    early = [];
    q.forEach(function(x){ emit(x[0], x[1]); });
    loadData();
    refresh(false).catch(noop);
  });
})();
